import {useTranslation} from 'hooks/translations/useCustomTranslation';
import React from 'react';

import {palette} from 'styles/mui/scss';

import {Typography} from 'components/basic-components';
import {CustomIcon} from 'components/basic-components/CustomIcon/CustomIcon';

export const SortMenuItem = ({sort}) => {
  const {t} = useTranslation('carFilter');
  switch (sort) {
    case 0:
      return (
        <>
          {/* <CustomIcon name="bars" style={{height: '24px', width: '24px', marginRight: '5px'}} /> */}
          <Typography sx={{fontWeight: 700, lineHeight: '24px', color: palette.colorGrey80}}>
            {t('relevance')}
          </Typography>
        </>
      );
    case 1:
      return (
        <>
          {/* <CustomIcon name="bars" style={{height: '24px', width: '24px', marginRight: '5px'}} /> */}

          <Typography sx={{fontWeight: 700, lineHeight: '24px', color: palette.colorGrey80}}>
            {t('price')}
          </Typography>
          <CustomIcon
            name="chevronDown"
            style={{height: '24px', width: '24px', marginRight: '5px'}}
          />
        </>
      );
    case -1:
      return (
        <>
          {/* <CustomIcon name="bars" style={{height: '24px', width: '24px', marginRight: '5px'}} /> */}

          <Typography sx={{fontWeight: 700, lineHeight: '24px', color: palette.colorGrey80}}>
            {t('price')}
          </Typography>
          <CustomIcon
            name="chevronUp"
            style={{height: '24px', width: '24px', marginRight: '5px'}}
          />
        </>
      );
    default:
      return (
        <>
          <CustomIcon name="bars" style={{height: '24px', width: '24px', marginRight: '5px'}} />
          <Typography sx={{fontWeight: 700, lineHeight: '24px', color: palette.colorGrey80}}>
            {t('relevance')}
          </Typography>
        </>
      );
  }
};
